import { deepCopy } from '@/utils/utils'
import store from '@/store'
import { divide, multiply } from 'mathjs'

const needToChangeAttrs = ['top', 'left', 'width', 'height', 'fontSize', 'lineHeight']
export default function changeComponentsSizeWithScale(scale) {
  const componentData = deepCopy(store.state.compose.componentData)
  componentData.forEach(component => {
    Object.keys(component.style).forEach(key => {
      if (needToChangeAttrs.includes(key)) {
        if (key === 'fontSize' && component.style[key] === '') return
        if (key === 'lineHeight' && component.style[key] === '') return

        // 根据原来的比例获取样式原来的尺寸
        // 再用原来的尺寸 * 现在的比例得出新的尺寸
        component.style[key] = format(getOriginStyle(component.style[key], store.state.compose.canvasStyleData.scale), scale)
      }
    })
  })

  store.commit('setComponentData', componentData)
  // 更新画布数组后，需要重新设置当前组件，否则在改变比例后，直接拖动圆点改变组件大小不会生效 https://github.com/woai3c/visual-drag-demo/issues/74
  store.commit('setCurComponent', { component: componentData[store.state.compose.curComponentIndex], index: store.state.compose.curComponentIndex })
  store.commit('setCanvasStyle', {
    ...store.state.compose.canvasStyleData,
    scale
  })
}

export function resetComponentsSizeWithScale(componentData, originScale, scale) {
  try {
    componentData.forEach(component => {
      Object.keys(component.style).forEach(key => {
        if (needToChangeAttrs.includes(key)) {
          if (key === 'lineHeight' && component.style[key] === '') return
          // 根据原来的比例获取样式原来的尺寸
          // 再用原来的尺寸 * 现在的比例得出新的尺寸
          let px = format(getOriginStyle(component.style[key], originScale), scale)
          px = Math.ceil(px / window.devicePixelRatio)
          component.style[key] = px
        }
      })
    })
  } catch (error) {
    console.log(error)
  }
}

const needToChangeAttrs2 = ['width', 'height', 'fontSize', 'lineHeight']
export function changeComponentSizeWithScale(component) {
  Object.keys(component.style).forEach(key => {
    if (needToChangeAttrs2.includes(key)) {
      if (key === 'fontSize' && component.style[key] === '') return

      component.style[key] = format(component.style[key], store.state.canvasStyleData.scale)
    }
  })
}

export function changeDevicePixelRatio(num) {
  return Math.ceil(num / window.devicePixelRatio)
}

function format(value, scale) {
  return multiply(value, divide(parseFloat(scale), 100))
}

function getOriginStyle(value, scale) {
  return divide(value, divide(parseFloat(scale), 100))
}
